export const colors = {
  primary: [
    'border-neutral-50 hover:border-base-primary',
    'focus:border-primary-700',
    'focus:ring-primary-50',
    'focus:shadow-primary',
    'active:border-primary-700',
  ].join(' '),

  secondary: [
    'border-neutral-50 hover:border-base-primary',
    'focus:border-secondary-accent',
    'focus:ring-secondary-50',
    'focus:shadow-secondary',
    'active:border-secondary-accent',
  ].join(' '),

  neutral: [
    'border-neutral-50 hover:border-base-primary',
    'focus:border-base-primary',
    'focus:ring-neutral-200',
    'focus:shadow-sm',
    'active:border-base-primary',
  ].join(' '),

  warning: [
    'border-warning-400 hover:border-warning-400',
    'focus:border-warning-400',
    'focus:ring-warning-200',
    'focus:shadow-warning',
    'active:border-warning-400',
  ].join(' '),

  error: [
    'border-secondary-accent hover:border-secondary-accent',
    'focus:border-secondary-accent',
    'focus:ring-secondary-50',
    'focus:shadow-secondary',
    'active:border-secondary-accent',
  ].join(' '),
} as const;
